'use client';
import { useEffect, useState } from 'react';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { MlAbaForm } from '@/components/molecules';
import { getAbaFormRes } from '@/lib/contentstack-sdk';
import { EClickableSize } from '@/components/atoms/at-clickable/at-clickable.types';
import { TOrContentBlockCS, IAbaFormButton } from './ml-aba-form.types';

export const MlAbaFormCs = ({}: TOrContentBlockCS) => {
  const [abaData, setAbaData] = useState();
  useEffect(() => {
    getAbaFormRes().then((res) => setAbaData(res));
  }, []);

  if (!abaData) return;

  const {
    body,
    cta_outline,
    cta_text,
    cta_variant,
    cta_size = EClickableSize.LG,
    aria_label,
  } = abaData;

  const ctaProps: IAbaFormButton = {
    outline: cta_outline,
    label: cta_text,
    variant: cta_variant,
    size: cta_size,
    aria_label,
  };
  return (
    <MlAbaForm ctaProps={ctaProps}>
      <RenderRichText body={body} className="prose-h4:lg:mb-16" />
    </MlAbaForm>
  );
};
